<template>
  <div class="tkIntList full-height linear-main3">
    <div>
      <ld-header
        @click-left="back"
        :transparent="true"
        :white="true"
      >
        <span v-show="!firstFlight&&tkIntSearchInfo.queryStr.travelType==2&&tkIntSearchInfo.showIntModel">{{ $t('C174','去程') }}：</span>
        <span v-show="firstFlight&&tkIntSearchInfo.queryStr.travelType==2&&tkIntSearchInfo.showIntModel">{{ $t('C175','返程') }}：</span>
        {{ tkIntSearchInfo.depport.cityName }}⇀{{ tkIntSearchInfo.arrport.cityName }}
        <template v-slot:right >
          <span
            v-if="false"
            @click="changeModel"
            v-show="tkIntSearchInfo.queryStr.travelType==2&&tkIntSearchInfo.roundtrip==0"
          >{{ tkIntSearchInfo.showIntModel ? '切换往返组合' : '切换自由搭配' }}</span>
        </template>
      </ld-header>

      <list-date
        :date-info="formatDate(tkIntSearchInfo.queryStr.departDate)"
        @prevDay="getDate"
        @toggle="showDate"
        @afterDay="getDate"
        :show-next="tkIntSearchInfo.queryStr.travelType==2&&tkIntSearchInfo.showIntModel||tkIntSearchInfo.queryStr.travelType==1"
      >
        <span
          slot="date"
          v-if="tkIntSearchInfo.queryStr.travelType==2&&tkIntSearchInfo.showIntModel==false"
        >
          去 {{ tkIntSearchInfo.departDate.monDay }} {{ tkIntSearchInfo.departDate.week }}&nbsp;  -  &nbsp;
          返 {{ tkIntSearchInfo.arriveDate.monDay }} {{ tkIntSearchInfo.arriveDate.week }}
        </span>
      </list-date>

      <van-popup
        v-model="showPlanes"
        class="popup-width"
        :close-on-popstate="true"
      >
        <tk-int-voyage
          v-if="tkIntSearchInfo.flights[0]"
          :flights="[tkIntSearchInfo.flights[0].qflightBean]"
        />
      </van-popup>

      <div class="wrapper">
        <mescroll-vue
          ref="mescroll"
          :down="down"
        >
          <div class="list">
            <!--显示第一程-->
            <div
              v-if="firstFlight&&tkIntSearchInfo.queryStr.travelType==2&&tkIntSearchInfo.showIntModel"
              class="pad-b-5 firstFlight"
            >
              <van-cell
                is-link
                class="round-sm"
                @click="showPlanes=true"
              >
                <span>去</span>
                {{ tkIntSearchInfo.flights[0].qflightBean.departDate }}
                {{ tkIntSearchInfo.flights[0].qflightBean.departTime }}&nbsp;
                {{ tkIntSearchInfo.flights[0].qflightBean.price.mainAirlineName }} | {{ tkIntSearchInfo.flights[0].qflightBean.cabin.cabinName }}
              </van-cell>
            </div>
            <!-- 航班列表 -->
            <div
              v-for="(info, flightIndex) in flightMap"
              :key="flightIndex"
              @click="toCabin(info)"
            >
              <!--
			<transition name="van-slide-right">
              <div
                class="pad-b-5"
                v-show="info.isShow"

              >
                <flight
                  :flight-obj="info"
                  :arr-set="arrSet"
                />
              </div>
            </transition> -->
              <div
                v-if="info.isShow"
                class="pad-b-5"
              >
                <van-row
                  class="box"
                  type="flex"
                  align="center"
                >
                  <van-col span="19">
                    <div class="pad-b-5">
                      <van-row
                        type="flex"
                        align="center"
                        class="text-center pad-b-5"
                      >
                        <van-col span="8">
                          <p class="font20 font-bold text-space-1">
                            {{ info.qflightBean.departTime }}
                          </p>
                          <p class="font12 gray">
                            {{ info.qflightBean.departAirportName|airportName }}  {{ info.qflightBean.departTerminal }}
                          </p>
                        </van-col>
                        <van-col
                          span="8"
                          class="font10 gray"
                        >
                          <!--                          <p v-show="info.qflightBean.transferNum>0">
                                                      {{ $t('transfer','中转') }}
                                                    </p>-->
                          <span>{{ info.qflightBean.flyTimeStr || durationo(info.qflightBean) }}</span>
                          <icon-arrow-line/>
                          <span v-show="info.qflightBean.transferNum>0">
                            <span class="main-color turn">转 {{ info.qflightBean.transferTimeStr }}</span>
                            <br>
                            <span
                              v-for="t in info.qflightBean.transferAirportList"
                              :key="t.transferCityName"
                              class="main-color discom">
                              {{ t.transferCityName }}
                            </span>
                          </span>
                        </van-col>
                        <van-col span="8">
                          <p class="font20 font-bold text-space-1">
                            {{ info.qflightBean.arriveTime }} <sup class="font10" />
                            <sup class="font10" v-show="(time(info.qflightBean.arriveDate,info.qflightBean.departDate))">+{{ getDaysBetweenDates(info.qflightBean.arriveDate, info.qflightBean.departDate) }}</sup>
                          </p>
                          <p class="font12 gray">
                            {{ info.qflightBean.arriveAirportName|airportName }}  {{ info.qflightBean.arriveTerminal }}
                          </p>
                        </van-col>
                      </van-row>
                      <div class="font12 gray" v-if="info.qflightBean.allFlightList && info.qflightBean.allFlightList.length > 1">
                        <span v-for="(item,index) in info.qflightBean.allFlightList" :key="index">
                          &nbsp;
                          <img :src="item.airlineImg" class="airIcon">
                          {{ item.airlineName }}丨{{ item.flightNo }}
                        </span>
                        <!--                        &nbsp;
                        <img :src="info.qflightBean.allFlightList[0].airlineImg" class="airIcon">
                        {{ info.qflightBean.allFlightList[0].airlineName }}丨{{ info.qflightBean.allFlightList[0].flightNo }}丨{{ info.qflightBean.allFlightList[0].model }}-->
                      </div>
                      <div class="font12 gray" v-if="info.qflightBean.allFlightList && info.qflightBean.allFlightList.length == 1">
                        &nbsp;
                        <img :src="info.qflightBean.allFlightList[0].airlineImg" class="airIcon"> {{ info.qflightBean.allFlightList[0].airlineName }}丨{{ info.qflightBean.allFlightList[0].flightNo }}丨{{ info.qflightBean.allFlightList[0].model }}
                      </div>
                    </div>
                    <div
                      class="pad-b-5"
                      v-if="info.hflightBean"
                    >
                      <van-row
                        type="flex"
                        align="center"
                        class=" text-center"
                      >
                        <van-col span="8">
                          <p class="font20 black text-space-1">
                            {{ info.hflightBean.departTime }}
                          </p>
                          <p class="font12 gray">
                            {{ info.hflightBean.departAirportName|airportName }}  {{ info.hflightBean.departTerminal }}
                          </p>
                        </van-col>
                        <van-col
                          span="8"
                          class="font10 gray"
                        >
                          <p v-show="info.qflightBean.transferNum>0">
                            {{ $t('transfer','中转') }}
                          </p>
                          <span>{{ info.qflightBean.flyTimeStr || durationo(info.qflightBean) }}</span>
                          <icon-arrow-line/>
                          <span class="main-color turn">转</span>
                          <span
                            v-for="t in info.hflightBean.trfAirportMap"
                            :key="t.transferCityName"
                            class="main-color"
                          >{{ t.transferCityName }}</span>
                        </van-col>
                        <van-col span="8">
                          <p class="font20 black text-space-1">
                            {{ info.hflightBean.arriveTime }}
                          </p>
                          <p class="font12 gray">
                            {{ info.hflightBean.arriveAirportName|airportName }}  {{ info.hflightBean.arriveTerminal }}
                          </p>
                        </van-col>
                      </van-row>
                      <van-row :gutter="0">
                        <van-col :span="1" />
                        <van-col>
                          <p class="font12 gray">
                            <img
                              :src="info.hflightBean.allFlightList[0].airlineImg"
                              class="airIcon"
                            > {{ info.hflightBean.allFlightList[0].airlineName }}丨{{ info.hflightBean.allFlightList[0].flightNo }}丨{{ info.hflightBean.allFlightList[0].model }}
                            {{ info.hflightBean.flyTimeStr }}
                          </p>
                        </van-col>
                      </van-row>
                    </div>
                  </van-col>
                  <van-col span="5">
                    <div class="font-lg money-color text-right">
                      <span class="font10">&yen;</span>
                      <span class="font20">{{ info.minPrice+(info.minTax||0) }}</span>
                    </div>
                    <div class="gray text-right font10">
                      含税价
                    </div>
                  </van-col>
                </van-row>
              </div>
            </div>
          </div>
          <nomore v-if="Blankscreen" />
        </mescroll-vue>
      </div>
    </div>


    <!--  -->
    <ld-tabbar>
      <van-row
        type="flex"
        align="center"
        class="bg-white  full-width text-center font12 shadow"
      >
        <van-col
          span="8"
          @click="fliters(1)"
        >
          <ld-icon
            class="icon"
            gradient
            icon-class="linear-main2"
            type="iconico_home_committed"
          />
          <div>时间  <span v-show="v==1">早-晚</span> <span v-show="v==2">晚-早</span></div>
        </van-col>
        <van-col
          span="8"
          @click="fliters(2)"
        >
          <ld-icon
            class="icon"
            gradient
            icon-class="linear-main2"
            type="iconjiage"
          />
          <div>价格  <span v-show="v==4">低-高</span> <span v-show="v==3">高-低</span> </div>
        </van-col>
        <van-col
          span="8"
          @click="toggle('tkFilter')"
        >
          <ld-icon
            class="icon"
            gradient
            icon-class="linear-main2"
            type="iconshaixuan1"
          />
          <div>{{ $t('C121','筛选') }}</div>
        </van-col>
      </van-row>
    </ld-tabbar>

    <tk-filter
      :filter-data="filterData"
      ref="tkFilter"
      @clear="clearing"
      @ensure="ensure"
      @get-term="getTerm"
      @nolimit="nolimit"
    />
    <!--  -->
    <!-- <ld-date
      ref="date"
      :date="tkIntSearchInfo.departDate.date"
      :min-date="tkIntSearchInfo.minDate"
      :max-date="tkIntSearchInfo.maxDate"
      @selected="changeDate"
    />
    <ld-date
      ref="date1"
      :mode="2"
      :start-date="tkIntSearchInfo.departDate.date"
      :end-date="tkIntSearchInfo.arriveDate.date"
      :min-date="tkIntSearchInfo.minDate"
      :max-date="tkIntSearchInfo.maxDate"
      @selected="changeDate"
    />  -->
    <Ld-calendar
      ref="date"
      :type="dateType"
      @selected="getDate"
      start-text="去程"
      end-text="回程"
    />
  </div>
</template>

<script>
import MescrollVue from 'mescroll.js/mescroll.vue'
import {Cell,Popup} from 'vant'
import { objToArr } from 'Utils/object.js'
import nomore from 'Common/ldNoMore'
import { mapGetters } from 'vuex'
import iconArrowLine from 'Common/iconArrowLine'
import listDate from 'Components/tk/listDate'
import tkFilter from 'Components/tk/filter'
import { formatDate } from 'Utils/dateUtil'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import tkIntVoyage from 'Views/TkInt/components/voyage'
import flight from 'Components/tk/flight'
import { duration } from 'Utils/dateUtil'


export default {
  name: 'TkIntList',
  components: {
    MescrollVue,
    iconArrowLine,
    listDate,
    ldTabbar,
    nomore,
    tkFilter,
    [Cell.name]:Cell,
    [Popup.name]:Popup,
    tkIntVoyage,
    LdCalendar: () => import('Common/ldCalendar'),
    flight
  },
  data() {
    return {
      down:{use:false},
      showPlanes:false,
      flightMap: [], //航班
      firstFlight:false,
      violateList: {}, //违背事项
      filterData:{
        depTime: [
          { name: '00:00-06:00', checked: false },
          { name: '06:00-12:00', checked: false },
          { name: '12:00-18:00', checked: false },
          { name: '18:00-24:00', checked: false }
        ],
        canbin: [
          { name: '经济舱',value:'Y', checked: false },
          { name: '头等舱/公务舱',value:'C', checked: false }
        ],
        hkgs: [],
        arrPlane: [],
        depPlane: [],
        tsfCity:[],//中转
        seltime: true,//不限
        seldepPlane: true,
        selarrPlane: true,
        selcabin: true,
        selhkgs: true,
        seltsfCity:true,
        items: [{ text: '起飞时间' }, { text: '机场' }, { text: '航空公司' },{ text: '中转机场' },{ text: '舱位' }],
        index: 2,
        direct:false,
        shared:false,
        sharFlight:false
      },
      v: 2,
      timer:0,
      timearr:[],
      deparr:[],
      arrarr:[],
      cabinarr:[],
      hkgsarr:[],
      tsfCityarr:[],
      loading:0,
      dateType:'single',
      fromrouter:false,
      Blankscreen:false
    }
  },
  computed: {
    ...mapGetters({
      tkIntSearchInfo: 'tkInt/tkIntSearchInfo',
      travelerList: 'tkInt/travelerList',//出行人列表
      pageCtrl: 'serviceCtrl', //页面控制信息
      tripType: 'tripType',
      userInfo:'userInfo',
    })
  },
  created() {
    if(this.tkIntSearchInfo.roundtrip==1&&this.tkIntSearchInfo.flights[0]){ //单程
      console.log("返回的第二程")
      let arr=this.tkIntSearchInfo.arrport,arriveAirport=this.tkIntSearchInfo.queryStr.arriveAirport
      let dep=this.tkIntSearchInfo.depport,departAirport=this.tkIntSearchInfo.queryStr.departAirport
      this.tkIntSearchInfo.depport=arr
      this.tkIntSearchInfo.arrport=dep
      this.tkIntSearchInfo.queryStr.arriveAirport=departAirport
      this.tkIntSearchInfo.queryStr.departAirport=arriveAirport
      this.tkIntSearchInfo.queryStr.departDate=this.tkIntSearchInfo.arriveDate.date
      this.firstFlight= true
    }
    this.tkIntSearchInfo.queryStr.requestId=''
    if(this.tkIntSearchInfo.queryStr.travelType==2 && !this.tkIntSearchInfo.showIntModel){//往返刚进的时候
      this.changeModel()
    }else{//单程
      this.search()
    }
    // this.search()

  },
  beforeRouteEnter(to, from, next) {
    next(vm => {//摆烂写法,没有更好的办法解决,/tr/trDetail点击回退没反应的问题
      // 通过 vm 实例访问组件实例
      //   if(from.name=='trDetail' || (vm.$data.fromrouter=='/home' || vm.$data.fromrouter=='/tr/trQuery')){

      //   }else{
      vm.$data.fromrouter=from.fullPath
      //   }
    });
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    clearTimeout(this.timer)
    next()
  },
  beforeDestroy(){
    this.$toast.clear()
    clearTimeout(this.timer)
  },
  methods: {
    formatDate,
    load(){//此方法只会调用一次
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration:0
      })
      this.loading=function(){}
    },
    //查询
    search() {
      this.Blankscreen = false
      if (this.loading == 0) {
        this.loading += 1
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0
        })
      }
      if (this.flightMap.length == 0 && this.tkIntSearchInfo.queryStr.startCount > 0) {
        this.tkIntSearchInfo.queryStr.startCount = 0
      }
      // this.tkIntSearchInfo.queryStr.showStop=true
      this.$api['tkIntQuery/queryFlightMinPrice'](this.tkIntSearchInfo.queryStr)
        .then(res => {
          let cache = res.data || {}
          if (cache.requestId) {
            if (this.tkIntSearchInfo.flights[this.tkIntSearchInfo.roundtrip]) {
              this.tkIntSearchInfo.flights[this.tkIntSearchInfo.roundtrip].requestId = cache.requestId
            } else {
              this.tkIntSearchInfo.flights[this.tkIntSearchInfo.roundtrip] = {requestId: cache.requestId}
            }
            this.tkIntSearchInfo.queryStr.requestId = cache.requestId
          }
          if (cache.flightList) {
            cache.flightList.forEach(item => {
              item.isShow = true
            })
          }
          if (cache.stopFlag == 1) {
            if (cache.flightList) {
              this.Blankscreen = true
            }
            if (cache.flightList) {
              this.flightMap = this.flightMap.concat(cache.flightList)
              this.dayMinPriceBean = cache.dayMinPriceBean
              Object.assign(this.filterData, this.getFilterData())//获取列表中航司 重装城市
              this.v = 3
              this.fliters(2)//按价格排序
            }
            this.$toast.clear()
            this.tkIntSearchInfo.queryStr.cabinReqId = ''
            this.loading = 0
            this.$toast.clear()
            clearTimeout(this.timer)
          } else {
            if (cache.flightList && (cache.flightList.length >= this.tkIntSearchInfo.queryStr.count)) {
              this.flightMap = this.flightMap.concat(cache.flightList)
              this.tkIntSearchInfo.queryStr.startCount = this.flightMap.length + 1
            }
            this.timer = setTimeout(() => {
              this.search()
            }, 1000)
          }
          // if(this.tkIntSearchInfo.showMinPriceTips){
          // 	var str=this.tkIntSearchInfo.depport.cityName+'-'+this.tkIntSearchInfo.arrport.cityName+' '
          //     +this.tkIntSearchInfo.departDate.date+ ' 的最低价航班为：'+this.dayMinPriceBean.qcDepartTime+
          //     ' / '+this.dayMinPriceBean.flightNo+' / '+(this.dayMinPriceBean.cabinName||'')+
          //     '('+this.dayMinPriceBean.cabin+')  ￥'+(this.dayMinPriceBean.salePrice)
          //     +',请优先选择最低价航班。'
          // 	this.$dialog.alert({
          // 		title: '提示',
          // 		message: str
          // 	})
          // }
          // if(this.flightMap.length==0){
          // 	this.Blankscreen=true
          // }
        }).catch(res => {
          this.loading = 0
          this.$toast.clear()
          this.$toast(res.errMsg)
        })
    },
    toCabin(info) {
      let flights=this.tkIntSearchInfo.flights
      Object.assign(flights[this.tkIntSearchInfo.roundtrip] , info)
      this.tkIntSearchInfo.violateList = this.violateList
      if(this.loading==0){
        this.loading+=1
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration:0
        })
      }
      this.$api['tkIntQuery/queryMoreCabin']({
        'flightSn': info.flightSn,
        'flightReqId': this.tkIntSearchInfo.queryStr.requestId,
        'corpId': '',
        'cabinType': '',
        'tripType': this.tripType,
        'infNum': this.tkIntSearchInfo.queryStr.infNum,
        'chdNum': this.tkIntSearchInfo.queryStr.chdNum,
        'aduNum': this.tkIntSearchInfo.queryStr.aduNum,
        'requestId': this.tkIntSearchInfo.queryStr.cabinReqId
      }).then(res => {
        let cache=res.data||{}
        flights[this.tkIntSearchInfo.roundtrip].flightReqId=this.tkIntSearchInfo.queryStr.requestId
        if(cache.requestId){
          flights[this.tkIntSearchInfo.roundtrip].cabinList=cache.cabinBeanList||[]
          flights[this.tkIntSearchInfo.roundtrip].cabinReqId=cache.requestId
          this.tkIntSearchInfo.queryStr.cabinReqId=cache.requestId
        }
        this.$store.commit('tkInt/tkIntSearchInfo',{flights:flights})
        if(cache.stopFlag==1){
          this.loading=0
          this.$toast.clear()
          if(cache.cabinBeanList&&cache.cabinBeanList.length>0){
            this.$store.commit('tkInt/tkIntSearchInfo',this.tkIntSearchInfo)
            this.$router.push({
              path: '/tk/tkIntCabin',
              query: { text: '我是阿格斯之盾' }
            })
          }else{
            this.$toast('未获取到舱位数据')
            this.tkIntSearchInfo.queryStr.cabinReqId=''
          }
        }else{
          this.timer=setTimeout(()=>{
            this.toCabin(flights[this.tkIntSearchInfo.roundtrip])
          },1000)
        }
      }).catch(res=>{
        this.loading=0
        this.$toast.clear()
        this.$toast(res.errMsg)
      })
    },
    getFilterData(){
      // 中转城市
      let tsfCity=[],hkgs=[],arrPlane=[],depPlane=[]
      this.flightMap.forEach(item=>{
        let	q=item.qflightBean,h=item.hflightBean
        if(q.transferNum>0){
          tsfCity=tsfCity.concat(q.transferAirportList.map(el=>{return {name:el.transferCityName,value:el.transferAirport,checked:false}}))
        }
        if(q.allFlightList&&q.allFlightList.length>0){
          hkgs=hkgs.concat(q.allFlightList.map(el=>{return {name:el.airlineName,value:el.airline,checked:false}}))
          depPlane=depPlane.concat(q.allFlightList.map(el=>{return {name:el.departAirportName,value:el.departAirport,checked:false}}))
          arrPlane=arrPlane.concat(q.allFlightList.map(el=>{return {name:el.arriveAirportName,value:el.arriveAirport,checked:false}}))
        }
        if(h&&h.allFlightList&&h.allFlightList.length>0){
          if(h.transferNum>0){
            tsfCity=tsfCity.concat(h.transferAirportList.map(el=>{return {name:el.transferCityName,value:el.transferAirport,checked:false}}))
          }
          hkgs=hkgs.concat(h.allFlightList.map(el=>{return {name:el.airlineName,value:el.airline,checked:false}}))
          depPlane=depPlane.concat(h.allFlightList.map(el=>{return {name:el.departAirportName,value:el.departAirport,checked:false}}))
          arrPlane=arrPlane.concat(h.allFlightList.map(el=>{return {name:el.arriveAirportName,value:el.arriveAirport,checked:false}}))
        }
      })
      return {
        tsfCity:this.distinct(tsfCity),
        hkgs: this.distinct(hkgs),
        arrPlane: this.distinct(arrPlane),
        depPlane: this.distinct(depPlane),
      }
    },
    distinct(arr){
      if(arr&&arr.length>0){
        let has={}
        arr.forEach(item=>{
          if(!has[item.value]){
            has[item.value]=item
          }
        })
        return objToArr(has)
      }
      return[]
    },
    showDate(){
      //显示单程往程
      console.log('15366333')
      if(this.pageCtrl.isChangeDate){
        let defaultDate
        // if(this.tkIntSearchInfo.queryStr.travelType==2){//往返跟单程
        // 	if(this.tkIntSearchInfo.showIntModel){
        // 		defaultDate=this.tkIntSearchInfo.departDate.date
        // 		this.dateType='single'
        // 	}else{
        // 		defaultDate=[this.tkIntSearchInfo.departDate.date,this.tkIntSearchInfo.arriveDate.date]
        // 		this.dateType='range'  //选日期来回，选二个日期
        // 	}
        // }else {
        // 	defaultDate=[this.tkIntSearchInfo.departDate.date,this.tkIntSearchInfo.arriveDate.date]
        // 	this.dateType='range' //选日期来回，选二个日期
        // }
        defaultDate=this.tkIntSearchInfo.departDate.date
        this.dateType='single'
        this.$refs.date.toggle({
          defaultDate:defaultDate,
          minDate:this.tkIntSearchInfo.minDate,
          maxDate:this.tkIntSearchInfo.maxDate
        })
      }
    },
    getDate(days){
      if(this.pageCtrl.isChangeDate){
        let returnDate=''
        if(Array.isArray(days)){//往返
          returnDate=days[1]
          this.tkIntSearchInfo.queryStr.returnDate = days[1]
          this.tkIntSearchInfo.departDate=formatDate(days[0])
          this.tkIntSearchInfo.arriveDate=formatDate(days[1])
        }else{
          if(this.tkIntSearchInfo.queryStr.travelType==2){
            if(this.tkIntSearchInfo.roundtrip==1){
              if (days&&days.length>3) {
                returnDate=formatDate(days).date
              }else{
                returnDate=formatDate(this.tkIntSearchInfo.arriveDate.date, days).date
              }
              if(this.tkIntSearchInfo.arriveDate.date>returnDate){
                return
              }else{
                this.tkIntSearchInfo.arriveDate=formatDate(returnDate)
              }
            }else{
              if (days&&days.length>3) {
                returnDate=formatDate(days).date
              }else{
                returnDate=formatDate(this.tkIntSearchInfo.departDate.date, days).date
              }
              if(this.tkIntSearchInfo.departDate.date>returnDate){
                return
              }else{
                this.tkIntSearchInfo.departDate=formatDate(returnDate)
              }
            }
          }else{
            if (days&&days.length>3) {
              returnDate=formatDate(days).date
            }else{
              returnDate=formatDate(this.tkIntSearchInfo.departDate.date, days).date
            }
            this.tkIntSearchInfo.departDate=formatDate(returnDate)
          }
        }
        this.tkIntSearchInfo.queryStr.departDate = returnDate
        this.tkIntSearchInfo.queryStr.requestId=''
        this.flightMap=[]
        this.search()
      }
    },
    changeModel(){
      console.log("调这个接口")
      if(this.tkIntSearchInfo.showIntModel){
        this.tkIntSearchInfo.showIntModel=false
        this.tkIntSearchInfo.queryStr.returnDate=this.tkIntSearchInfo.arriveDate.date
      }else{
        this.tkIntSearchInfo.showIntModel=true
        this.tkIntSearchInfo.queryStr.returnDate=''
      }
      this.flightMap=[]
      this.tkIntSearchInfo.queryStr.requestId=''
      this.search()
    },
    toggle(name){
      this.$refs[name].toggle()
    },
    //获取选中数据
    getTerm(m, n, k) {
      switch (m) {
      //起飞时间
        case 0:
          for (let i = 0; i < this.filterData.depTime.length; i++) {
            let index = this.timearr.indexOf(n)
            if (k && index < 0) {
              this.timearr.push(n)
            } else if (!k && index >= 0) {
              this.timearr.splice(index, 1)
            }
          }
          this.filterData.seltime=!this.deparr.length>0
          break
        //起飞机场
        case 1:
          for (let i = 0; i < this.filterData.depPlane.length; i++) {
            let index = this.deparr.indexOf(n)
            if (k && index < 0) {
              this.deparr.push(n)
            } else if (!k && index >= 0) {
              this.deparr.splice(index, 1)
            }
          }
          this.filterData.seldepPlane=!this.deparr.length>0
          break
        //到达机场
        case 2:
          for (let i = 0; i < this.filterData.arrPlane.length; i++) {
            let index = this.arrarr.indexOf(n)
            if (k && index < 0) {
              this.arrarr.push(n)
            } else if (!k && index >= 0) {
              this.arrarr.splice(index, 1)
            }
          }
          this.filterData.selarrPlane=!this.arrarr.length>0
          break
        //舱位类型
        case 3:
          for (let i = 0; i < this.filterData.canbin.length; i++) {
            let index = this.cabinarr.indexOf(n)
            if (k && index < 0) {
              this.cabinarr.push(n)
            } else if (!k && index >= 0) {
              this.cabinarr.splice(index, 1)
            }
          }
          break
        //航空公司
        case 4:
          for (let i = 0; i < this.filterData.hkgs.length; i++) {
            let index = this.hkgsarr.indexOf(n)
            if (k && index < 0) {
              this.hkgsarr.push(n)
            } else if (!k && index >= 0) {
              this.hkgsarr.splice(index, 1)
            }
          }
          this.filterData.selhkgs=!this.hkgsarr.length>0
          break
        //中转城市
        case 5:
          for (let i = 0; i < this.filterData.tsfCity.length; i++) {
            let index = this.tsfCityarr.indexOf(n)
            if (k && index < 0) {
              this.tsfCityarr.push(n)
            } else if (!k && index >= 0) {
              this.tsfCityarr.splice(index, 1)
            }
          }
          this.filterData.seltsfCity=!this.tsfCityarr.length>0
      }
    },
    //不限
    nolimit: function(n) {
      switch (n) {
        case 'seltime':
          getfs(this.filterData.depTime)
          break
        case 'seldepPlane':
          getfs(this.filterData.depPlane)
          break
        case 'selarrPlane':
          getfs(this.filterData.arrPlane)
          break
        case 'selcabin':
          getfs(this.filterData.canbin)
          break
        case 'selhkgs':
          getfs(this.filterData.hkgs)
          break
        case 'seltsfCity':
          getfs(this.filterData.tsfCity)
          break
      }
      function getfs(m) {
        for (let i = 0; i < m.length; i++) {
          m[i].checked = false
        }
      }
    },
    clearing: function() {
      let arr = ['seltime', 'seldepPlane', 'selarrPlane', 'selcabin', 'selhkgs','seltsfCity']
      for (let i = 0; i < arr.length; i++) {
        this.nolimit(arr[i])
      }
    },
    //确定
    ensure: function() {
      let flightList = this.flightMap
      flightList = objToArr(flightList)
      for (let i = 0; i < flightList.length; i++) {
        flightList[i].isShow = true
      }

      result('departTime', this.timearr)//出发时间
      result('departAirportName', this.deparr)//起飞机场
      result('arriveAirportName', this.arrarr)//到达机场
      result('airlineName', this.hkgsarr)//航空公司
      result('transferCityName', this.tsfCityarr)//航空公司
      if(this.filterData.direct){
        result('direct')//直飞
      }
      if(this.filterData.sharFlight){
        result('sharFlight')
      }
      this.flightMap = flightList

      function result(name , arr) {//筛选结果
        let bool=arr&&arr.length>0
        let obj={
          departTime(){
            if(bool==false) return
            flightList.forEach(el=>{
              if(el.isShow){
                let q=el.qflightBean
                let bl=arr.some(item=>{
                  let start=item.split('-')[0]
                  let end=item.split('-')[1]
                  return q[name]>=start&&q[name]<=end
                })
                if(bl){ el.isShow=true}else {el.isShow=false}
              }
            })
          },
          departAirportName:some,
          arriveAirportName:some,
          airlineName:some,
          transferCityName(){
            if(bool==false) return
            flightList.forEach(el=>{
              if(el.isShow){
                let q=el.qflightBean
                let h=el.hflightBean
                if(q.transferNum>0){
                  let tsf=q.transferAirportList
                  if(h&&h.transferNum>0){
                    tsf=tsf.concat(h.transferAirportList)
                  }
                  let bl=arr.some(item=>{
                    return tsf.some(info=>{
                      return info[name]==item
                    })
                  })
                  if(bl){ el.isShow=true}else {el.isShow=false}
                }else{
                  el.isShow=false
                }
              }
            })
          },
          direct(){//直飞
            flightList.forEach(el=>{
              if(el.isShow){
                let q=el.qflightBean
                if(q.transferNum<=0){ el.isShow=true}else {el.isShow=false}
              }
            })
          },
          sharFlight(){
            flightList.forEach(el=>{
              if(el.isShow){
                if(el.flightSn.indexOf('*')>-1){
                  el.isShow=false
                }
              }
            })
          }
        }
        obj[name](name,arr)
      }
      function some(name,arr){
        if(arr&&arr.length>0) {
          flightList.forEach(el=>{
            if(el.isShow){
              let q=el.qflightBean
              let bl=arr.some(item=>{
                if(q.allFlightList){
                  el.isShow=q.allFlightList.some( info => info[name]==item )
                }else{el.isShow=false}
              })
            }
          })
        }
      }

    },
    //排序
    fliters(n) {
      let flightList = this.flightMap
      switch (n) {
        case 1:
          if (this.v == 1 || this.v == 0) {
            this.v = 2
          } else {
            this.v = 1
          }
          this.flightMap =flightList.sort((a,b)=>{
            let r = a.qflightBean.departTime > b.qflightBean.departTime //升序
            return  this.v == 1?(r ? 1 : -1):(r ? -1 : 1)
          })
          break
        case 2:
          if (this.v == 4) {
            this.v = 3
          } else {
            this.v = 4
          }
          this.flightMap =flightList.sort((a,b)=>{
            let a_price = a.minPrice + (a.minTax || 0),
              b_price = b.minPrice + (b.minTax || 0)
            return this.v == 4 ? (a_price-b_price):(b_price-a_price)
          })
          break
      }
    },
    back(){
      this.$store.commit('tkInt/CLEAR_ALL',{})
      if(localStorage.getItem('Pagenew')==1){
        this.$router.push({path:'/home'})
      }else{
        this.$router.push({path:this.tkIntSearchInfo.backPath})
      }


    },
    durationo(info){
      return duration(info)
    },
    time(start, end) {
      if (start > end) {
        return true
      }
      return false
    },
    getDaysBetweenDates(date1Str, date2Str) {
      // 将日期字符串转换为Date对象
      const date1 = new Date(date1Str);
      const date2 = new Date(date2Str);
      // 计算两个日期的时间戳差值
      const differenceInTime = Math.abs(date2.getTime() - date1.getTime());
      // 将毫秒差转换为天数
      const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
      return differenceInDays;
    }
  },
}

</script>

<style lang="less" scoped>
@import '~Assets/styles/business';

.tkIntList {
    .pad-b-5 {
        padding-bottom: 5px;
    }
    .wrapper {
        height: calc(100vh - 142px);
        overflow: hidden;
    }
    .list{
        padding: 0 6px;
    }
    .box{
        background-color: @color-background-white;
		padding: 14px 12px 10px 12px;
		border-radius: 4px;
    }
    .icon{
        font-size: 18px;
        height: 18px;
    }
    .fliterBox {
        .left {
            width: 24%;
            float: left;
        }
        .right {
            width: 76%;
            float: left;
        }
    }
    .fliterBox::after {
        content: "";
        display: table;
        clear: both;
    }
    .fliter {
        height: 1rem;
        line-height: 1rem;
        border-bottom: 1px solid @color-background-lightGray;
        width: 100%;
        font-size: @font-size-30;
    }
    .firstFlight{
		span{
			display: inline-block;
			height: 0.32rem;
			width: 0.32rem;
			background-color: @color-background-green;
			font-size: @font-size-12;
			text-align: center;
			line-height: 0.32rem;
			color: @color-text-white;
		}
    }
}
.turn {
  padding: 0px 5px 0 5px;
  position: relative;
  top: -10px;
  background: white;
}
.discom{
	position: relative;
    top: -10px;
}
</style>
